export default "__VITE_ASSET__Bmo4vHN___"